import { $, $$, rect } from "@utils/dom";
import Viewport from "@utils/viewport";
import ResizeOrientation, { BEFORE_SCROLL_UPDATE as MAX_PRIORITY } from "@utils/resize";
// import { getOffset } from "@scroll/utils";
import { getTranslate } from "@utils/transform";
// import { inViewport } from "@utils/transform";
import { on, off } from "@utils/listener";
import anime from "animejs";
import { head } from "../../utils/dom";

const DEFAULT_OFFSET = 100;

class PbRowSplashPage {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this.header = $(".pb-row-splash-page__header", this.el);
    this.footer = $(".pb-row-splash-page__footer", this.el);
    this.form = $(".pb-row-splash-page__form", this.el);
    this.footerScrollEls = [...$$("[data-scroll]", this.footer)];
    this.ctaElements = [...$$(".pb-row-splash-page__cta, .pb-row-splash-page__footerLogo", this.el)];

    this._onCtaClick = this._onCtaClick.bind(this);
    this._onResize = this._onResize.bind(this);
    this._setTotalHeight = this._setTotalHeight.bind(this);
    this._setScrollOffsets = this._setScrollOffsets.bind(this);
    this._observeForm = this._observeForm.bind(this);
  }

  init() {
    this.observer = new MutationObserver(this._observeForm);
    this._setScrollOffsets();
  }
  destroy() {
    this.el = null;
    this.emitter = null;

    this.header = null;
    this.footer = null;
    this.observer = null;
    this.cta = null;

    this._onResize = null;
    this._observeForm = null;
  }

  start() {
    this._bindEvents();
    this._onResize();
  }

  stop() {
    this._unbindEvents();
  }

  _bindEvents() {
    ResizeOrientation.add(this._onResize, MAX_PRIORITY);
    this.observer.observe(this.form, { attributes: false, childList: true, subtree: true });
    if (this.ctaElements) on(this.ctaElements, "click", this._onCtaClick);
  }
  _unbindEvents() {
    ResizeOrientation.remove(this._onResize);
    this.observer.disconnect();
    if (this.ctaElements) off(this.ctaElements, "click", this._onCtaClick);
  }

  _onCtaClick(event) {
    if (event) event.preventDefault();

    const { scrollY } = window;
    const headerRec = rect(this.header);
    const options = {
      speed: 2500,
      scrollOffset: 0
    };

    // change scroll to direction based on scrollY position
    if (scrollY > 0) {
      options.scrollOffset = 0;
      options.speed = 1000;
    } else {
      options.scrollOffset = headerRec.height;
    }

    this.emitter.emit("SiteScroll.scrollTo", options.scrollOffset, {
      duration: options.speed,
      easing: "easeInOutQuart"
    });
  }

  _onResize() {
    this._setTotalHeight();
    this._setScrollOffsets();
  }

  _setTotalHeight() {
    const height = this.footer.offsetHeight + Viewport.height;

    this.el.style.setProperty("--total-height", `${height}px`);
  }

  _setScrollOffsets() {
    const footerRect = rect(this.footer);

    this.footerScrollEls.forEach((el) => {
      const bcr = rect(el);
      const translate = getTranslate(el);

      const top = bcr.top - translate.y;
      const bottom = bcr.top - translate.y + bcr.height;

      let scrollOffset = 0;

      if (this._isInViewport(el)) {
        const footerHeightDiff = Math.max(0, footerRect.height - Viewport.height);
        scrollOffset = 0 - top - footerHeightDiff;
      } else {
        scrollOffset = 0 - (footerRect.height - bottom) - bcr.height;
      }

      el.setAttribute("data-scroll-offset", `${scrollOffset}px, 0`);
    });
  }

  _isInViewport(el) {
    if (!el) return false;

    const bcr = rect(el);
    const translate = getTranslate(el);

    const top = bcr.top - translate.y + 100;
    const bottom = bcr.top - translate.y + bcr.height;

    return top < Viewport.height && bottom > 0;
  }

  _observeForm(mutationList, observer) {
    let DomHasChanged = false;

    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        DomHasChanged = true;
      }
    }

    if (DomHasChanged) this.emitter.emit("SiteScroll.update");
  }
}

export default PbRowSplashPage;
